module.exports = __webpack_public_path__ + "img/RS_Rune Sword.a8102599.png";